import api from "@/utils/http";

/**
 功能：
 time: 2026/3/4 15:30
 **/
export function getPartnerList(data) {
    return api.post('/admin/partner/getList', data)
}

/**
 功能：
 time: 2026/3/4 16:36
 **/
export function savePartner(data) {
    return api.post('/admin/partner/eSave', data)
}

/**
 功能：
 time: 2026/3/4 17:01
 **/
export function setAuthData(data) {
    return api.post('/admin/partner/setAuth', data)
}

/**
 功能：
 time: 2026/3/4 16:37
 **/
export function getPartnerDetail(partner_id) {
    return api.post('/admin/partner/getDetail', { partner_id: partner_id })
}

/**
 功能：
 time: 2026/3/4 15:30
 **/
export function deletePartner(partner_id) {
    return api.post('/admin/partner/del', {partner_id: partner_id})
}

/**
 功能：
 time: 2026/3/16 11:21
 **/
export function getPartnerAccount(partner_id) {
    return api.post('/admin/partner/getAccount', { partner_id: partner_id })
}

